import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

export type StatusTone = 'cyan' | 'amber' | 'red' | 'green' | 'ghost';

const toneClass: Record<StatusTone, string> = {
  cyan: 'chip--cyan',
  amber: 'chip--amber',
  red: 'chip--red',
  green: 'chip--green',
  ghost: 'chip--ghost',
};

export function StatusBadge({ tone, children, className }: { tone: StatusTone; children: ReactNode; className?: string }) {
  return <span className={cn('chip', toneClass[tone], className)}>{children}</span>;
}

export function orderStatusTone(status: string): StatusTone {
  switch (status) {
    case 'submitted':
      return 'cyan';
    case 'dispatched':
      return 'cyan';
    case 'confirmed':
      return 'green';
    case 'back_ordered':
      return 'amber';
    case 'failed':
      return 'red';
    default:
      return 'ghost';
  }
}

export function humaniseStatus(status: string): string {
  return status.replace(/_/g, ' ');
}
